import type { SchemaNodeLike } from '../../schema';
import type { Store } from '../store';
import { DataNode } from './data-node';

const EXTENSION_NAME = 'DATA';

export function createDataNode(schemaNode: SchemaNodeLike, store: Store) {
  if (!schemaNode) {
    throw new Error('Invalid schema node');
  }
  const dataNode = new DataNode();
  store.getRecordGroup(schemaNode.modelName as string).subscribe(dataNode);
  schemaNode.setExtension(EXTENSION_NAME, dataNode);
  return dataNode;
}

export function getDataNode(schemaNode: SchemaNodeLike) {
  if (!schemaNode) {
    return null;
  }
  return schemaNode.getExtension<DataNode>(EXTENSION_NAME) ?? null;
}

export { DataNode } from './data-node';
export { DataRef } from './data-ref';
export type { DataRefStatus } from './data-ref';
